import React from 'react';
import { Box, MenuList, Button, ListItemIcon, MenuItem, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useError } from 'services/ErrorContext';
import { theme } from 'theme/theme';
import { opcionesAdmin, opcionesUsuario } from 'utils/constants';
import { IMenuItem, IMenuUsuario } from 'utils/models/interfaces';

const MenuLogueado = ({ setOpen, usuario, handleLogout }: IMenuUsuario) => {
  const { clearError } = useError();
  const esAdmin = usuario?.Rol === 'Administrador';
  const esAlumno = usuario?.EsAlumno;
  const esSocio = usuario?.TipoSocio !== 'Nada';
  const opcionesUsuarioCliente = usuario
    ? opcionesUsuario
        .filter(opcion => esAlumno || opcion.text !== 'Mis talleres')
        .filter(opcion => esSocio || opcion.text !== 'Mis datos de socio')
    : null;

  const opcionesUsuarioAdmin =
    usuario && opcionesUsuarioCliente
      ? [...opcionesAdmin, ...opcionesUsuarioCliente].filter(opcion => opcion.text !== 'Mi cuenta')
      : null;

  const opcionesMenu = esAdmin ? opcionesUsuarioAdmin : opcionesUsuarioCliente;

  const handleCloseUserMenu = () => {
    setOpen(null);
    clearError();
  };

  return (
    <Box py={2} px={3}>
      <MenuList disablePadding sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {opcionesMenu?.map(({ text, path, icon: Icon }: IMenuItem) => (
          <NavLink to={path} key={path} className="menuLogueado">
            <MenuItem onClick={handleCloseUserMenu}>
              <ListItemIcon sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: '15px' }}>
                {Icon && <Icon sx={{ color: theme.palette.secondary.main }} />}
                <Typography fontSize="0.9rem" color="black">
                  {text}
                </Typography>
              </ListItemIcon>
            </MenuItem>
          </NavLink>
        ))}
      </MenuList>
      <Button variant="outlined" sx={{ mt: 2, ml: 1, mb: 1, color: theme.palette.primary.main }} onClick={handleLogout}>
        Salir
      </Button>
    </Box>
  );
};

export default MenuLogueado;
